var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main',[_c('Nuxt')],1),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loader"},[_vm._v("\n    Loading\n  ")]):_vm._e(),_vm._v(" "),(_vm.errors.length > 0)?_c('div',{staticClass:"loader"},[_c('ErrorOverlay')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }